var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"project-card",attrs:{"data-aos":"fade-down"},on:{"click":function($event){return _vm.$emit('openProject', _vm.projectKey)}}},[_c('img',{staticClass:"img_nano",attrs:{"src":require(`../assets/${_vm.info.img.nano}`)}}),_c('p',{staticClass:"project-title-nano"},[_c('b',[_vm._v(_vm._s(_vm.info.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }